import { withStyles } from '@material-ui/core/styles'
import TableCell from '@material-ui/core/TableCell'

const TableHeadCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.background.tableHead,
    // color: theme.palette.common.white,
  },
}))(TableCell)

export default TableHeadCell
